import Avatar from 'components/Avatar'
import { FormGroup } from 'components/inputs'
import {
  CustomSelect,
  ItemSource,
  SingleItemSelectedDefault,
  useCustomSelectStateFromItemSource,
} from 'components/inputs/CustomSelect'
import SearchResultItem from 'components/inputs/CustomSelect/SearchResultItem'
import Workspace from 'iam/models/Workspace'
import { observer } from 'mobx-react'
import * as React from 'react'
import WorkspaceSelectorViewModel from '../../../../WorkspaceSelectorViewModel'

interface CompactWorkspaceSelectorProps {
  vm: WorkspaceSelectorViewModel
}

export default observer(function CompactWorkspaceSelector({
  vm,
}: CompactWorkspaceSelectorProps) {
  const itemSource = React.useMemo(
    () =>
      ItemSource.static(vm.availableWorkspaces, (item, text) =>
        item.name.toLowerCase().includes(text.toLowerCase()),
      ),
    [vm.availableWorkspaces],
  )
  const change = React.useCallback(
    (workspace: Workspace | undefined) => vm.selectWorkspace(workspace || null),
    [vm],
  )
  const selectProps = useCustomSelectStateFromItemSource({
    itemSource,
  })
  return (
    <FormGroup>
      <CustomSelect
        {...selectProps}
        placeholder="Select a Workspace"
        itemToString={(v) => String(v?.name)}
        disabled={vm.disabled}
        focus$={vm.step.becomeActive$}
        onFocus={vm.step.onBecameActive}
        value={vm.selectedWorkspace ?? undefined}
        onChange={change}
        multi={false}
        data-test="compact-workspace-selector"
        renderItem={(itemProps) => (
          <SingleItemSelectedDefault
            {...itemProps}
            visual={
              <Avatar
                size={24}
                subject={{
                  displayName: itemProps.item.name,
                  avatar: itemProps.item.branding.logos.icon,
                }}
              />
            }
          />
        )}
        renderSearchItem={({ item, itemToString, ...itemProps }) => (
          <SearchResultItem
            {...itemProps}
            visual={
              <Avatar
                size={24}
                subject={{
                  avatar: item.branding.logos.icon,
                  displayName: item.name,
                }}
              />
            }
          >
            {item.name}
          </SearchResultItem>
        )}
      />
    </FormGroup>
  )
})
